// dependancys
import React, { useEffect, useState } from "reactn";
import PropTypes from "prop-types";

// components
import Loader from "shared-anpost-components/components/loader/Loader";
import GlobalError from "shared-anpost-components/components/globalError/GlobalError";
import AddressesGrid from "./AddressesGrid";

// config
import { AddressesFiltersConfig, AddressesConfig } from "./Addresses.config";

// apis
import { getProfile, getJWTInfo, getFavourites } from "../../../services/Api";

// hooks
import profileHooks from "../../../hooks/profileHooks";

const Addresses = props => {
    const { history } = props;

    const { setMoneyUser, values } = profileHooks();

    const [userAddresses, setUserAddresses] = useState([]);

    const [loader, setLoader] = useState(false);
    const [apiError, setApiError] = useState(false);

    const getFavouriteReceivers = (profileAddresses, userId) => {
        getJWTInfo().then(() => {
            getFavourites(userId)
                .then(res => {
                    if (res.status === 200) {
                        setLoader(false);
                        // set filter items
                        const favouriteAddresses = res.data.receivers.map(item => {
                            const tempItem = item;
                            tempItem.filter = "contactAddresses";
                            return tempItem;
                        });

                        setUserAddresses([...profileAddresses, ...favouriteAddresses]);
                    } else {
                        setLoader(false);
                        setApiError(true);
                    }
                })
                .catch(() => {
                    setLoader(false);
                    setApiError(true);
                });
        });
    };

    const setProfileCallback = (profileData, callback) => {
        let tempUserAddresses = [];
        let homeAddress = [];
        let businessAddress = [];
        let otherUserAddress = [];

        // all of the users addresses
        tempUserAddresses = profileData.addresses.map(item => {
            const tempItem = item;

            // this property `filter` is user to diffrentiate between contact addresses and personal adddresses in AddressesGrid
            tempItem.filter = "personalAddresses";
            return tempItem;
        });

        // Isolate the home, business and other user addresses for ordering purposes
        homeAddress = tempUserAddresses.filter(item => item.displayName === "Home");
        businessAddress = tempUserAddresses.filter(item => item.displayName === "Business");
        otherUserAddress = tempUserAddresses.filter(item => item.displayName !== "Home" && item.displayName !== "Business");

        // comment out getFavouriteReceivers and use the below if you want to just view addresses locally
        // setUserAddresses([...homeAddress, ...businessAddress, ...otherUserAddress]);
        // setLoader(false);

        getFavouriteReceivers([...homeAddress, ...businessAddress, ...otherUserAddress], profileData.uid);

        // set Money user flag
        setMoneyUser(profileData.ecoSystemCustomer === "true");

        if (callback) {
            callback(profileData.profile.firstName || profileData.email);
        }
    };

    const updateAddresses = (userId, callback) => {
        setLoader(true);
        getJWTInfo().then(() => {
            const profileData = JSON.parse(sessionStorage.getItem("userProfile"));
            if (profileData && profileData.uid) {
                setProfileCallback(profileData, callback);
            } else {
                getProfile(userId).then(res => {
                    if (res.status === 200) {
                        sessionStorage.setItem("userProfile", JSON.stringify(res.data));
                        setProfileCallback(res.data, callback);
                    } else {
                        setApiError(true);
                        setLoader(false);
                    }
                });    
            }
        });
    };

	const onAddressUpdate = () => {
		updateAddresses(values.ciamUserId);
	}

    // for dev purposes, when developing locally
    useEffect(() => {
        // if dev mode or the user is alreadey logged in
        if (values.loggedIn) {
            updateAddresses(values.ciamUserId);
        }

        if (window.apDevMode) {
            setUserAddresses(AddressesConfig.receivers);
        }
    }, []);

    const closeFunc = () => {
        setApiError(false);
    };

    return (
        <>
            {loader && <Loader local/>}
            {apiError && <GlobalError closeFunc={closeFunc} />}
            {!loader && <AddressesGrid items={userAddresses} filters={AddressesFiltersConfig.filters} history={history} filterActive="all" deleteBtn editBtn newItem onAddressUpdate={onAddressUpdate}></AddressesGrid>}
        </>
    );
};

export default Addresses;
Addresses.propTypes = {
    history: PropTypes.object
};
